import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appBlur: false,
    lightboxVisible: false,
    lightboxImages: [],
    lightboxSelected: null,
  },
  mutations: {
    showLightbox(state) {
      state.appBlur = true;
      state.lightboxVisible = true;
    },
    hideLightbox(state) {
      state.lightboxVisible = false;
      state.appBlur = false;
    },
    setLightboxSelected(state, num) {
      state.lightboxSelected = num;
    },
    lightboxImages(state, images) {
      state.lightboxImages = images;
    },
  },
  actions: {},
});
